import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "placeholder text-hide-1"
}
const _hoisted_2 = {
  key: 1,
  class: "content text-ellipsis"
}

import { type } from 'os';
import { ref, useSlots, computed } from 'vue';
type borderEnum = keyof typeof borderTypeMap;

interface Props {
  label?: string;
  labelWidth?: string;
  align?: 'left' | 'right' | 'center';
  radius?: string;
  placeholder?: string;
  part?: boolean;
  content?: string;
  icon?: string;
  borderType?: borderEnum;
  background?: string;
  textAlign?: string;
  height?: string;
  mt?: string;
  padding?: string;
  disabled?: boolean;
  placeholderColor?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    label: {},
    labelWidth: {},
    align: {},
    radius: {},
    placeholder: {},
    part: { type: Boolean },
    content: {},
    icon: {},
    borderType: {},
    background: {},
    textAlign: {},
    height: {},
    mt: {},
    padding: {},
    disabled: { type: Boolean },
    placeholderColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "2f7748da": (props.mt ? props.mt : "20px"),
  "6ecff258": (props.padding?props.padding:"0 20px"),
  "25cd0ee0": (props.height),
  "36a2ea4b": (props.radius),
  "e5141f2a": (props.labelWidth),
  "b3fc03a8": (props.align),
  "246b884c": (props.part ? "block" : "none"),
  "1290117f": (props.textAlign),
  "be21e524": (props.placeholderColor? props.placeholderColor : "#ccc"),
  "be4959d0": (props.placeholderColor? props.placeholderColor : "#999")
}))

const slot = useSlots();

/**
 * @params {String} label
 * @params {String} labelWidth 选择器label的宽度
 * @params {String} align 选择器label的对齐方式 left | right | center
 * @params {String} radius 选择器的圆角
 * @params {String} placeholder 选择器的placeholder
 *
 * */
// enum borderEnum {
//   Full = 'full',
//   Left = 'left',
//   Right = 'right',
//   Top = 'top',
//   Bottom = 'bottom',
//   None = 'none',
// }

const borderTypeMap = {
  full: { border: '1px solid #ccc' },
  left: { 'border-left': '1px solid #ccc' },
  bottom: { 'border-bottom': '1px solid #ccc' },
  none: { border: 'none' },
};

const props = __props;

const _style = computed(() => {
  return borderTypeMap[props.borderType] || '';
});

return (_ctx: any,_cache: any) => {
  const _component_taro_view = _resolveComponent("taro-view")!

  return (_openBlock(), _createBlock(_component_taro_view, { class: "cell-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "cell-content",
        style: _normalizeStyle(_style.value)
      }, [
        (_ctx.label || _unref(slot).label)
          ? (_openBlock(), _createBlock(_component_taro_view, {
              key: 0,
              class: "cell-label"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "label", {}, () => [
                  _createElementVNode("span", null, _toDisplayString(props.label), 1)
                ], true)
              ]),
              _: 3
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_taro_view, { class: "cell-text" }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "text", {}, () => [
              (!_unref(slot).content && !props.content)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.placeholder), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.content), 1))
            ], true),
            (_ctx.icon && !_ctx.disabled)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([`iconfont`, _ctx.icon, '_icon_className']),
                  style: {"font-size":"20px"}
                }, null, 2))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 4)
    ]),
    _: 3
  }))
}
}

})